import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import {
  DELETE_RESOURCE_ALLOCATION,
  updateCache
} from '~/modules/resourcing/hooks/useDeleteResourceAllocation';

const useDeleteResourceAllocationFromProject = () => {
  const [deleteResourceAllocation] = useMutation(DELETE_RESOURCE_ALLOCATION);

  const deleteResourceAllocationFromProject = useCallback(
    ({ projectUri, resourceAllocationId, resourceRequestId }) => {
      deleteResourceAllocation({
        variables: {
          input: {
            id: resourceAllocationId
          }
        },
        optimisticResponse: {
          __typename: 'Mutation',
          isOptimistic: true,
          deleteResourceAllocation2: {
            __typename: 'DeleteResourceAllocationResult',
            id: resourceAllocationId
          }
        },
        update: updateCache({ projectUri, resourceRequestId })
      });
    },
    [deleteResourceAllocation]
  );

  return { deleteResourceAllocationFromProject };
};

const useResourceAllocationActionHandlers = ({
  resourceRequest,
  requestAccessLevel
}) => {
  const {
    deleteResourceAllocationFromProject
  } = useDeleteResourceAllocationFromProject();

  const onRemoveAllResources = useCallback(() => {
    resourceRequest.resourceAllocations.forEach(allocation =>
      deleteResourceAllocationFromProject({
        projectUri: resourceRequest.projectUri,
        resourceAllocationId: allocation.id,
        resourceRequestId: allocation.resourceRequestId,
        requestAccessLevel
      })
    );
  }, [
    deleteResourceAllocationFromProject,
    requestAccessLevel,
    resourceRequest.projectUri,
    resourceRequest.resourceAllocations
  ]);

  return {
    onRemoveAllResources
  };
};

export default useResourceAllocationActionHandlers;
